import React from 'react';

// Context
export const CUSTOMERS = '[Customers]';

// commands
export const FETCH_CUSTOMER = `${CUSTOMERS} FETCH_CUSTOMER`;
export const FETCH_CUSTOMERS = `${CUSTOMERS} FETCH_CUSTOMER`;
export const FETCH_ALL_CUSTOMERS = `${CUSTOMERS} FETCH_ALL_CUSTOMERS`;
export const CREATE_CUSTOMERS = `${CUSTOMERS} CREATE_CUSTOMERS`;
export const UPDATE_CUSTOMER = `${CUSTOMERS} UPDATE_CUSTOMER`;

// document
export const SET_CUSTOMERS = `${CUSTOMERS} SET`;
export const INSERT_CUSTOMERS = `${CUSTOMERS} INSERT`;
export const PUT_CUSTOMER = `${CUSTOMERS} PATCH`;

// event
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS'; // receives business customers data from get business customers
export const UPLOAD_CUSTOMER_CSV_SUCCESS = 'UPLOAD_CUSTOMER_CSV_SUCCESS'; // receives csv data return from parsing customer csv file
export const ADD_CUSTOMERS = 'ADD_CUSTOMERS'; // Adds customers to state
export const UPDATE_CUSTOMERS = 'UPDATE_CUSTOMERS';
export const CREATE_CUSTOMERS_SUCCESS = 'CREATE_CUSTOMERS_SUCCESS';
export const STOP_CUSTOMER_LOAD = 'STOP_CUSTOMER_LOAD'; // used to stop the loading indication on a customer
export const UPLOAD_CUSTOMER_DOCUMENT = 'UPLOAD_CUSTOMER_DOCUMENT';

export const fetchCustomers = companyId => ({
    type: FETCH_CUSTOMERS,
    payload: {companyId}
});

export const setCustomers = data => ({
    type: SET_CUSTOMERS,
    payload: {data}
});

export const insertCustomers = data => ({
    type: INSERT_CUSTOMERS,
    payload: {data}
});

export const fetchCustomer = (companyId, customerId) => ({
    type: FETCH_CUSTOMER,
    payload: {
        companyId,
        customerId
    }
});

export const fetchAllCustomer = () => ({
    type: FETCH_ALL_CUSTOMERS,
    payload: {}
});

export const updateCustomer = (companyId, customerId, customersForUpdate) => ({
    type: UPDATE_CUSTOMER,
    payload: {
        data: customersForUpdate,
        companyId,
        customerId
    }
});

export const uploadCustomerDocument = (companyId, customerId, data) => ({
    type: UPLOAD_CUSTOMER_DOCUMENT,
    payload: {
        data,
        companyId,
        customerId
    }
});

export const putCustomer = customerForUpdate => ({
    type: PUT_CUSTOMER,
    payload: {data: customerForUpdate}
});

export const createCustomers = (companyId, customerForCreation) => ({
    type: CREATE_CUSTOMERS,
    payload: {
        data: customerForCreation,
        companyId
    }
});
